<template>
    <div id="status-calendar">
        <div class="separator-planned"></div>
        <div v-if="show">
            <span id="progress-bar" v-if="shipment.conventional_shipment && shipment.conventional_shipment.id != 0 && steps && steps.length>0">
              <span id="full" :style="{'flex-grow': filled}"/>
              <span id="empty" :style="{'flex-grow': empty}"/>
            </span>
            <div class="wrapper">
                <div :class="'step ' + step.class" v-for="(step, index) in steps" :key="index" :style="planned ? 'padding-bottom: 1em; min-height:100px':''"
                :title="step.tooltip">
                    <span class="flag-wrapper" v-if="step.flag">
                      <img :src="`https://hatscripts.github.io/circle-flags/flags/${step.flag}.svg`" width="36">
                      <span :class="'ico-wrapper '+ step.img">
                        <icon icoClass="flag-event-ico" :selected='step.img'/>
                      </span>
                    </span>
                    <span :class="'ico-wrapper '+ step.img" v-else>
                      <icon icoClass="event-ico" :selected='step.img'/>
                    </span>
                    <div class="bold-title">{{step.port.locode}}</div>
                    <div class="mini-title">{{SHIPMENT_TYPE[step.type]}}</div>
                    <div v-if="!step.date" class="bold-title dates">
                      <div class="date-group" v-if="step.type !='pol'">
                        <span class="date-wrapper arrival">
                            <div class="date-title">ETA</div>
                            <div class="date" v-if="step.type != 'pol' && step.arrival_planned" :style="step.arrival_planned? 'color: black':' color: grey'">{{step.arrival_planned| toString}}</div>
                        </span>
                        <span class="date-wrapper arrival">
                            <div class="date-title">ATA</div>
                            <div class="date" v-if="step.type != 'pol' && step.arrival_actual" :style="step.arrival_actual? 'color: black':' color: grey'">{{step.arrival_actual| toString}}</div>
                        </span>
                      </div>
                      <div class="date-group" v-if="step.type !='pod'">
                        <span class="date-wrapper departure">
                            <div class="date-title">ETD</div>
                            <div class="date" v-if="step.type != 'pod' && step.departure_planned" :style="step.departure_planned? 'color: black':' color: grey'">{{step.departure_planned | toString}}</div>
                        </span>
                        <span class="date-wrapper departure">
                            <div class="date-title">ATD</div>
                            <div class="date" v-if="step.type != 'pod' && step.departure_actual" :style="step.departure_actual? 'color: black':' color: grey'">{{step.departure_actual | toString}}</div>
                        </span>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icon from './../../svg/events'
import moment from 'moment'
import conventionalShipment from '@/models/conventional/shipment'

export default {
  name: 'status-calendar',
  props: ['shipment', 'planned'],
  mounted () {
    if (!this.planned) {
      this.show = true
    }
  },
  components: {icon},
  data () {
    return {
      show: false,
      SHIPMENT_TYPE: conventionalShipment.SHIPMENT_TYPE
    }
  },
  computed: {
    empty () {
      if (this.steps) {
        return this.steps.length * 2 - this.filled
      }
      return 0
    },
    filled () {
      var amount = 0
      this.steps.forEach((step, index) => {
        if ((step.arrival_actual) || (this.steps[index + 1] && this.steps[index + 1].arrival_actual)) {
          amount = (index + 1) * 2 - 1
        }
        if ((step.departure_actual) || (this.steps[index + 1] && this.steps[index + 1].departure_actual) || (step.arrival_actual && step.type === 'pod')) { amount = (index + 1) * 2 }
      })
      return amount
    },
    steps () {
      var steps = []
      if (this.shipment) {
        if (this.shipment.pol) {
          this.shipment.pol.img = 'anchor'
          this.shipment.pol.flag = (this.shipment.pol.port.country.code) ? this.shipment.pol.port.country.code.toLowerCase() : 'xx'
          steps.push(this.shipment.pol)
        }
        if (this.shipment.transhipments && this.shipment.transhipments.length > 0) {
          this.shipment.transhipments.forEach((step) => {
            step.img = 'transhipment'
            step.flag = (step.port.country.code) ? step.port.country.code.toLowerCase() : 'xx'
            if (step.arrival_actual) step.arrival_actual = new Date(step.arrival_actual)
            if (step.arrival_planned) step.arrival_planned = new Date(step.arrival_planned)
            if (step.departure_planned) step.departure_planned = new Date(step.departure_planned)
            if (step.departure_actual) step.departure_actual = new Date(step.departure_actual)
            steps.push(step)
          })
        }
        if (this.shipment.pod) {
          this.shipment.pod.img = 'anchor'
          this.shipment.pod.flag = (this.shipment.pod.port.country.code) ? this.shipment.pod.port.country.code.toLowerCase() : 'xx'
          steps.push(this.shipment.pod)
        }
      }
      return steps
    }
  },
  filters: {
    toString: function (value) {
      if (value instanceof Date && !isNaN(value.valueOf())) {
        let dateString = moment(value).format('YYYY-MM-DD HH:mm')
        return dateString
      }
      if (typeof (value) === 'object' && value) {
        return value.__str__
      }
      if (value) {
        return value.toString()
      }
      return ''
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.separator-planned {
    display: inline-block;
    height: 1px;
    width: 100%;
    padding: 0;
    margin: 0;
    vertical-align: top;
}
.flag-wrapper {
  display: inline-block;
  margin-top: -.4em;
  img {
    filter: contrast(0.65) brightness(1.25);
  }
  .ico-wrapper{
    line-height: 1em;
    margin-left: -1em;
    z-index: 200;
    position: relative;
    box-shadow: -.1em .1em .2em rgba($color: #000000, $alpha: .5);
  }
}
.dates {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
}
.date-group{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.date-wrapper {
  margin: .3em;
  flex:1;
}
.date-title {
    font-size: .7em;
    font-family: MuseoSans-900;
    color: gray;
    white-space: nowrap;
}
.date {
    font-size: .85em;
    margin-top: .5em;
    white-space: nowrap;
}
#status-calendar{
    position: relative;
}
#full {
    background: rgb(48, 177, 65);
}
#empty {
    background: white;
}
#progress-bar {
    border: 1px solid lightgray;
    border-radius: 6px;
    height: 32px;
    width: calc(100% - 4em);
    display: flex;
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    margin: 2em;
    overflow: hidden;
}
.wrapper {
    display: flex;
}
.step{
    margin: 0 .5em 1.5em .5em;
    background: white;
    border: 1px solid lightgray;
    border-radius: 10px;
    min-height: 150px;
    width: 150px;
    flex-grow: 1;
    padding: 1em .3em;
    text-align: center;
    padding-bottom: 3.5em;
}
.loaded .ico-wrapper, .discharge .ico-wrapper {
    background: #e21b7a;
}
.loaded, .discharge, .empty_pickup, .origin, .dlv, .empty_return, .lif {
  // ducks up the progress bar flex: 1;
}
 .ico-wrapper, .empty_pickup .ico-wrapper, .ico-wrapper, .empty_return .ico-wrapper, .lif .ico-wrapper {
    background: #39bc08;
}
.dlv  .ico-wrapper, .origin .ico-wrapper{
  background: #ff7525;
}
.ico-wrapper {
    background: rgb(28, 167, 209);
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
}

@media only screen and (max-width: 1000px) {
#progress-bar {
    flex-direction: column;
    height: calc(100% - 4em);
    width: 32px;
}
.wrapper {
    flex-direction: column;
}
.step{
    flex: 1;
    min-width: 75%;
    padding: 1em .3em;
    text-align: center;
    padding-left: 3.5em;
}
}
.help-cursor{
  cursor:help;
}

.anchor {
    background: #39bc08;
}
</style>



// WEBPACK FOOTER //
// src/components/conventional/StatusCalendarConventionalShipment.vue